// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__Cxxfp","label":"styles_label__8ThJm","icon":"styles_icon__bwiFH"};